export const SuccessNoteIcon = () => (
    <svg
        width='143'
        height='102'
        viewBox='0 0 143 102'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M131.355 102C133.345 102.001 135.287 101.656 136.915 101.013C138.544 100.369 139.78 99.4589 140.455 98.4054C143.419 93.7588 146.031 85.1514 134.425 75.841C121.592 65.5467 95.9193 54.9044 77.8623 53.8142C49.5731 52.107 37.2244 77.4976 24.5312 81.8165C13.5643 85.5479 2.12444 84.3124 0.048527 96.0071C-0.0786084 96.7189 0.0446641 97.4378 0.411306 98.1228C0.777948 98.8078 1.38078 99.4455 2.18538 99.9994C2.98998 100.553 3.98059 101.013 5.10066 101.351C6.22072 101.69 7.4483 101.901 8.71331 101.972C9.03338 101.99 9.35446 101.999 9.67654 102L131.355 102Z'
            fill='#E5F3F7'
        />
        <path
            d='M109.129 0.227539V75.5098L104.422 70.8027L104.261 70.9639L99.4821 75.7412H99.3356L94.3972 70.8027L94.236 70.9639L89.5397 75.6582L84.5192 70.6377L79.5065 75.6504L74.6559 70.7988L74.4948 70.6377L74.3337 70.7988L69.4684 75.6631L64.4431 70.6377L64.2819 70.7988L59.4304 75.6514L54.5788 70.7988L54.4177 70.6377L54.2575 70.7988L49.7097 75.3457V0.227539H109.129Z'
            fill='#FFFAEB'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M81.6106 18.2915V20.1226H56.2151V18.2915H81.6106Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M73.345 11.2686V13.0996H56.2151V11.2686H73.345Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M77.3899 25.3125V27.1436H56.2151V25.3125H77.3899Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M71.7629 32.334V34.165H56.2151V32.334H71.7629Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M79.1917 39.355V41.186H56.2151V39.355H79.1917Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M75.9836 46.3765V48.2075H56.2151V46.3765H75.9836Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M73.345 53.3989V55.23H56.2151V53.3989H73.345Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M70.1799 60.4194V62.2505H56.2151V60.4194H70.1799Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M102.362 18.2915V20.1226H93.3207V18.2915H102.362Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M102.362 11.2686V13.0996H93.3206V11.2686H102.362Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M102.362 25.3125V27.1436H93.3207V25.3125H102.362Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M102.362 32.334V34.165H93.3207V32.334H102.362Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M102.362 39.355V41.186H93.3207V39.355H102.362Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M102.362 46.3765V48.2075H93.3207V46.3765H102.362Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M102.362 53.3989V55.23H93.3207V53.3989H102.362Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M102.362 60.4194V62.2505H93.3207V60.4194H102.362Z'
            fill='white'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M109.357 55.6846C116.638 55.6848 122.539 61.5875 122.539 68.8682C122.539 76.1487 116.637 82.0506 109.357 82.0508C102.076 82.0508 96.1735 76.1488 96.1733 68.8682C96.1733 61.5873 102.076 55.6846 109.357 55.6846Z'
            fill='#0088B2'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M116.706 63.5513C116.906 63.5425 117.102 63.6028 117.262 63.7212L117.327 63.7759C117.476 63.9105 117.572 64.0913 117.602 64.2876L117.61 64.3726C117.622 64.6005 117.544 64.8241 117.393 64.9946L107.699 75.6763C107.641 75.7403 107.574 75.7954 107.5 75.8394L107.424 75.8794C107.346 75.9159 107.262 75.9407 107.177 75.9526L107.091 75.9604C107.078 75.9607 107.067 75.9614 107.057 75.9614L106.974 75.9565C106.81 75.9408 106.654 75.8788 106.525 75.7778L106.461 75.7241L101.367 70.9175C101.226 70.7787 101.137 70.5967 101.114 70.4019L101.109 70.3179C101.104 70.1188 101.169 69.9252 101.29 69.769L101.345 69.7046C101.501 69.5391 101.716 69.4417 101.943 69.4331C102.142 69.4256 102.337 69.486 102.495 69.604L102.561 69.6587L106.84 73.6958L107.009 73.855L107.165 73.6831L116.107 63.8296C116.242 63.6823 116.425 63.5873 116.621 63.5591L116.706 63.5513Z'
            fill='#E5F3F7'
            stroke='#1D2939'
            strokeWidth='0.455357'
        />
        <path
            d='M40.894 92.3129L37.6134 91.9229C37.7611 90.6813 37.928 89.1898 37.9394 88.9453C37.9394 88.961 37.9394 88.9738 37.9394 88.9837H41.2429C41.2423 89.0828 41.2423 89.3842 40.894 92.3129Z'
            fill='#E98862'
        />
        <path
            d='M27.7322 92.7067L24.4286 92.6958C24.4286 92.6958 24.4396 89.2846 24.4396 88.9824H27.7432C27.7434 89.2856 27.7322 92.7067 27.7322 92.7067Z'
            fill='#E98862'
        />
        <path
            d='M36.2932 91.2684L42.1122 91.1693C41.8702 85.0406 41.829 78.0308 41.7641 71.6876C41.7461 70.1154 41.6274 68.5459 41.4086 66.9889C40.4724 60.2688 39.8617 53.5875 38.6012 46.9058L38.5592 46.9182L38.4362 46.0798L26.4697 45.3413L25.8468 53.1596C25.8468 53.1596 24.2882 80.2059 23.5774 91.0809L29.3765 91.5709C30.4214 80.9085 32.0386 65.3726 33.033 54.1715C34.1751 59.6249 34.952 65.2714 35.9451 70.6781C36.1439 77.4458 36.3116 84.5208 36.2932 91.2684Z'
            fill='#262626'
        />
        <path
            d='M31.7475 93.9843C31.8363 93.9838 31.9241 93.9651 32.0053 93.9292C32.0866 93.8934 32.1596 93.8411 32.2198 93.7758C32.2799 93.7104 32.326 93.6334 32.355 93.5494C32.3841 93.4655 32.3955 93.3765 32.3886 93.2879C32.3791 93.1652 32.3346 93.0477 32.2605 92.9493C32.1864 92.851 32.0857 92.7759 31.9704 92.7328L28.1258 91.4451C28.0513 91.4204 27.9723 91.4122 27.8943 91.4208C27.8164 91.4295 27.7412 91.4549 27.6739 91.4952C27.1454 91.862 26.5132 92.0495 25.8702 92.03C25.3693 91.9945 24.8885 91.8189 24.4827 91.5232C24.447 91.494 24.4038 91.4756 24.358 91.47C24.3122 91.4644 24.2658 91.4719 24.2242 91.4917C24.1825 91.5115 24.1473 91.5427 24.1227 91.5817C24.0981 91.6207 24.0851 91.6659 24.0852 91.712V93.592C24.0852 93.6474 24.0962 93.7024 24.1174 93.7536C24.1387 93.8048 24.1699 93.8513 24.2092 93.8904C24.2485 93.9296 24.2951 93.9606 24.3464 93.9816C24.3977 94.0027 24.4527 94.0134 24.5082 94.0132L31.7475 93.9843Z'
            fill='#C1D8ED'
        />
        <path
            d='M44.9182 93.9843C45.007 93.9839 45.0948 93.9651 45.1761 93.9293C45.2574 93.8934 45.3304 93.8412 45.3905 93.7758C45.4507 93.7105 45.4967 93.6334 45.5258 93.5495C45.5548 93.4655 45.5662 93.3765 45.5593 93.2879C45.5498 93.1652 45.5054 93.0477 45.4313 92.9494C45.3572 92.851 45.2566 92.7759 45.1412 92.7328L41.2965 91.4451C41.222 91.4204 41.1431 91.4122 41.0651 91.4208C40.9872 91.4295 40.912 91.4549 40.8447 91.4952C40.3162 91.862 39.6839 92.0495 39.0409 92.03C38.5401 91.9945 38.0593 91.8189 37.6536 91.5232C37.6179 91.494 37.5746 91.4755 37.5288 91.4699C37.483 91.4642 37.4366 91.4718 37.3949 91.4916C37.3532 91.5113 37.318 91.5426 37.2934 91.5816C37.2688 91.6206 37.2558 91.6658 37.2559 91.712V93.592C37.2559 93.6474 37.2669 93.7023 37.2881 93.7536C37.3094 93.8048 37.3406 93.8513 37.3799 93.8904C37.4192 93.9296 37.4658 93.9606 37.5172 93.9816C37.5685 94.0027 37.6234 94.0134 37.6789 94.0132L44.9182 93.9843Z'
            fill='#C1D8ED'
        />
        <path
            d='M42.188 33.4038C42.188 33.4038 43.831 31.925 43.9225 31.4235C44.0141 30.922 42.7373 30.0288 42.7373 30.0288C42.7373 30.0288 43.0644 29.6555 43.3809 29.234C43.7464 28.7476 44.0978 28.1969 43.9172 28.0809C43.7429 27.9691 43.3134 28.383 42.8854 28.8832C42.3348 29.5266 41.7883 30.3137 41.7883 30.3137C41.7883 30.3137 42.0008 29.4436 41.6668 29.4082C41.5295 29.3937 41.4309 29.534 41.255 30.1509C41.0553 30.854 40.6353 31.9198 40.6353 31.9198L42.188 33.4038Z'
            fill='#E98862'
        />
        <path
            d='M38.8999 41.6037C39.2411 41.6037 39.5745 41.5019 39.8575 41.3114C40.1405 41.1209 40.3603 40.8502 40.4886 40.5341L43.5716 32.9421L40.3942 31.6523L39.4597 33.9502L38.7271 30.2886L35.364 30.9615L37.2177 40.2252C37.29 40.5868 37.4769 40.9155 37.7508 41.1624C38.0247 41.4093 38.3709 41.5614 38.7381 41.596C38.7922 41.6012 38.8463 41.6037 38.8999 41.6037Z'
            fill='url(#paint0_linear_9666_141785)'
        />
        <path
            d='M44.4657 35.4506L42.5588 35.1463C42.4838 35.1343 42.4121 35.1067 42.3486 35.0651C42.285 35.0235 42.2309 34.9689 42.1899 34.905C42.1489 34.841 42.1219 34.7692 42.1106 34.694C42.0993 34.6189 42.104 34.5422 42.1244 34.4691L43.3241 30.1631C43.3596 30.0355 43.4409 29.9254 43.5524 29.8539C43.6638 29.7824 43.7977 29.7544 43.9285 29.7753L45.8355 30.0796C45.9105 30.0915 45.9821 30.1192 46.0457 30.1608C46.1092 30.2024 46.1633 30.257 46.2043 30.3209C46.2453 30.3849 46.2723 30.4567 46.2836 30.5319C46.2949 30.607 46.2902 30.6836 46.2698 30.7568L45.07 35.0628C45.0345 35.1903 44.9532 35.3004 44.8418 35.3719C44.7304 35.4434 44.5965 35.4714 44.4657 35.4506Z'
            fill='#C1D8ED'
        />
        <path
            d='M41.395 34.3211L42.5196 35.847C42.5196 35.847 45.5424 35.241 45.826 32.9123C45.8587 32.6449 45.8304 31.9022 45.4983 32.0018C44.6331 32.2611 43.5563 33.5888 42.8013 33.7653C42.9736 33.4568 43.1838 33.0212 43.0482 32.9414C42.6917 32.732 41.733 33.9962 41.395 34.3211Z'
            fill='#E98862'
        />
        <path
            d='M26.1934 29.5282C26.9124 28.8093 28.1535 28.3453 29.6665 28.3438C29.7799 29.2262 35.1373 29.2293 35.1781 28.3642C35.3826 28.3673 35.5414 28.3705 35.6405 28.3752C39.2769 28.5325 39.2662 31.4627 38.9085 34.7017L41.9004 33.382L43.2846 36.5201L38.5228 38.6201C38.5196 38.7145 38.5171 38.8088 38.5162 38.9032C38.4547 44.009 39.8341 44.9716 39.1546 46.532C38.4957 48.0467 25.5457 48.6759 25.3727 46.0114C25.2626 44.3157 26.7569 42.8356 26.7569 39.5308C26.7569 36.2261 23.7164 32.0056 26.1934 29.5282Z'
            fill='url(#paint1_linear_9666_141785)'
        />
        <path
            d='M35.1788 28.3642C35.138 29.2294 34.6675 30.5021 33.2155 30.5981C31.2805 30.7255 29.7799 29.2263 29.6665 28.3438H29.6714C31.5765 28.3438 34.0681 28.3469 35.1788 28.3642Z'
            fill='#E98862'
        />
        <path
            d='M30.2579 29.3058C30.2579 29.3058 31.4744 28.6608 31.2028 25.3483L33.716 24.8823C33.716 24.8823 33.4328 27.8521 34.7052 28.795L30.2579 29.3058Z'
            fill='#E98862'
        />
        <g opacity='0.15'>
            <path
                d='M34.1898 28.1743L32.1019 26.577L33.7418 26.5601C33.7892 27.1213 33.9412 27.6688 34.1898 28.1743Z'
                fill='black'
            />
        </g>
        <path
            d='M29.777 24.0643C29.9509 25.0693 30.4993 26.0207 31.3858 26.3451C32.4379 26.7303 33.2173 26.7564 34.4305 26.7564C36.086 26.7564 36.0313 25.0299 36.0779 23.2899C36.125 21.543 35.9857 19.6693 35.3313 19.0606C34.0258 17.8455 30.1921 18.615 29.7257 20.6472C29.4845 21.6986 29.6113 23.1083 29.777 24.0643Z'
            fill='#E98862'
        />
        <path
            d='M33.6618 23.2904C33.7877 23.2904 33.8898 23.1883 33.8898 23.0624C33.8898 22.9365 33.7877 22.8345 33.6618 22.8345C33.536 22.8345 33.4339 22.9365 33.4339 23.0624C33.4339 23.1883 33.536 23.2904 33.6618 23.2904Z'
            fill='#0F1011'
        />
        <path
            d='M35.4598 23.1429C35.5857 23.1429 35.6877 23.0409 35.6877 22.915C35.6877 22.7891 35.5857 22.687 35.4598 22.687C35.3339 22.687 35.2318 22.7891 35.2318 22.915C35.2318 23.0409 35.3339 23.1429 35.4598 23.1429Z'
            fill='#0F1011'
        />
        <path
            d='M35.8548 22.4282H35.8534L35.2496 22.4207C35.2355 22.4205 35.2216 22.4176 35.2087 22.412C35.1958 22.4065 35.1841 22.3985 35.1743 22.3884C35.1644 22.3783 35.1567 22.3664 35.1515 22.3534C35.1463 22.3403 35.1437 22.3264 35.1439 22.3123C35.1438 22.2982 35.1466 22.2842 35.1521 22.2712C35.1576 22.2582 35.1656 22.2464 35.1757 22.2365C35.1858 22.2267 35.1978 22.2189 35.211 22.2138C35.2241 22.2087 35.2381 22.2062 35.2523 22.2066L35.856 22.2141C35.8837 22.2153 35.9099 22.2272 35.929 22.2473C35.9481 22.2674 35.9586 22.2941 35.9585 22.3218C35.9583 22.3495 35.9474 22.3761 35.9281 22.3959C35.9087 22.4158 35.8825 22.4273 35.8548 22.4282Z'
            fill='#0F1011'
        />
        <path
            d='M33.1696 22.6484C33.1434 22.6484 33.1181 22.6387 33.0986 22.6213C33.079 22.6038 33.0665 22.5798 33.0635 22.5538C33.0604 22.5278 33.067 22.5016 33.082 22.4801C33.0969 22.4586 33.1193 22.4433 33.1447 22.4372L33.74 22.2938C33.7538 22.2903 33.7681 22.2896 33.7821 22.2917C33.7961 22.2937 33.8096 22.2986 33.8218 22.3059C33.8339 22.3132 33.8445 22.3229 33.8529 22.3343C33.8613 22.3458 33.8673 22.3588 33.8706 22.3726C33.8739 22.3864 33.8745 22.4007 33.8722 22.4147C33.87 22.4287 33.865 22.4421 33.8575 22.4541C33.85 22.4662 33.8402 22.4766 33.8287 22.4849C33.8171 22.4931 33.804 22.499 33.7902 22.5021L33.1948 22.6454C33.1865 22.6474 33.1781 22.6484 33.1696 22.6484Z'
            fill='#0F1011'
        />
        <path
            d='M31.6389 20.6657C31.8164 24.0582 31.4845 25.6352 31.2998 26.226C31.2876 26.265 31.2668 26.3006 31.2388 26.3303C31.2109 26.36 31.1765 26.383 31.1384 26.3975C31.1002 26.412 31.0593 26.4177 31.0186 26.414C30.978 26.4104 30.9387 26.3976 30.9037 26.3765C30.3129 26.0255 28.97 24.9308 28.517 22.069C28.1111 19.5051 30.0204 18.3736 31.2819 17.9962C32.3693 17.6709 33.8429 17.7338 35.0159 18.481C36.493 19.4219 36.2742 21.3582 36.2742 21.3582C34.482 21.4408 30.6527 21.5998 30.6527 21.5998'
            fill='#0F1011'
        />
        <path
            d='M32.4764 23.6205C32.4886 23.748 32.4754 23.8766 32.4375 23.9989C32.3996 24.1212 32.3377 24.2348 32.2555 24.333C32.1733 24.4312 32.0725 24.5121 31.9587 24.571C31.845 24.6299 31.7207 24.6655 31.5931 24.676C31.4655 24.6864 31.337 24.6713 31.2153 24.6317C31.0935 24.5921 30.9808 24.5286 30.8838 24.445C30.7868 24.3615 30.7073 24.2595 30.65 24.1449C30.5928 24.0304 30.5589 23.9056 30.5502 23.7778C30.5376 23.6509 30.5507 23.5228 30.5887 23.4011C30.6267 23.2793 30.6887 23.1665 30.7712 23.0692C30.8537 22.972 30.955 22.8924 31.0689 22.8351C31.1828 22.7778 31.3071 22.744 31.4343 22.7358C32.1231 22.7139 32.4328 23.0886 32.4764 23.6205Z'
            fill='#E98862'
        />
        <g opacity='0.15'>
            <path
                d='M34.6736 24.327C34.6548 24.327 34.6365 24.3203 34.6223 24.308C34.608 24.2957 34.5986 24.2787 34.5958 24.2601C34.593 24.2414 34.597 24.2224 34.607 24.2065C34.617 24.1905 34.6325 24.1787 34.6505 24.1732L35.1141 24.0308L34.7899 23.3087C34.7816 23.2898 34.7812 23.2683 34.7886 23.249C34.7961 23.2297 34.8109 23.2141 34.8298 23.2056C34.8486 23.1972 34.8701 23.1965 34.8895 23.2037C34.9089 23.2109 34.9246 23.2255 34.9333 23.2442L35.2941 24.0476C35.2986 24.0578 35.301 24.0688 35.301 24.08C35.301 24.0911 35.2986 24.1022 35.294 24.1123C35.2894 24.1225 35.2827 24.1316 35.2743 24.1389C35.266 24.1463 35.2561 24.1518 35.2455 24.1551L34.6967 24.3236C34.6892 24.3259 34.6815 24.327 34.6736 24.327Z'
                fill='black'
            />
        </g>
        <path
            d='M33.7675 24.8576C33.7675 24.8576 34.6089 24.9463 35.199 24.7402C35.199 24.7402 35.1943 25.2945 34.5285 25.349C33.8628 25.4036 33.7675 24.8576 33.7675 24.8576Z'
            fill='white'
        />
        <defs>
            <linearGradient
                id='paint0_linear_9666_141785'
                x1='39.4678'
                y1='30.2886'
                x2='39.4678'
                y2='41.6037'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#FFCC00' />
                <stop offset='1' stopColor='#0088B2' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_9666_141785'
                x1='34.2531'
                y1='28.3438'
                x2='34.2531'
                y2='47.8392'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#FFCC00' />
                <stop offset='1' stopColor='#0088B2' />
            </linearGradient>
        </defs>
    </svg>
);
